// Os inputs do checkout seguem `id = "checkout-" + nome do campo com "_" virando "-"`
// (ex.: card_expiration -> checkout-card-expiration).
export const getCheckoutFieldId = fieldName =>
  `checkout-${String(fieldName).replace(/_/g, "-")}`;

// O Formik devolve os erros na ordem do schema, não da tela: o "primeiro" erro pode estar abaixo de outro.
// Aqui escolhemos o primeiro campo com erro na ordem do DOM, rolamos até ele e focamos.
export const focusFirstInvalidField = (errors, root = document) => {
  const fields = Object.keys(errors || {})
    .map(name => root.getElementById?.(getCheckoutFieldId(name)))
    .filter(Boolean);

  if (!fields.length) return null;

  const [first] = fields.sort((a, b) =>
    a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
  );

  // scrollIntoView antes: campo desabilitado (ex.: CEP em busca) não aceita foco, mas ainda deve ficar visível.
  first.scrollIntoView?.({ block: "center", behavior: "smooth" });
  first.focus?.({ preventScroll: true });

  return first;
};
